<script setup lang="ts">
import { useSearchStore } from "@/stores/search";
import { computed, ref, onMounted, onBeforeMount } from "vue";
import ResultItems from "@/components/ResultItems/ResultItems.ce.vue";
import Teaser from "@/components/Teaser/Teaser.ce.vue";
import Pagination from "@/components/Pagination/Pagination.ce.vue";
import SearchFilterBox from "@/components/SearchFilterBox/SearchFilterBox.vue";
import { useScreens } from "vue-screen-utils";
import { DEFAULT_BREAKPOINT_DEFINITIONS } from "@/lib/util/breakpoint";
import { setI18nLocale } from "@/services/i18n";
import RestoreModal from "@/components/RestoreModal/RestoreModal.vue";

const props = defineProps({
    apiEndpoint: {
        type: String,
        default: "https://journaway.ddev.site:8081/",
    },
    ident: {
        type: String,
        default: "",
    },
    isWhitelabel: {
        type: Boolean,
        default: false,
    },
    isIframe: {
        type: Boolean,
        default: false,
    },
    backendApiEndpoint: {
        type: String,
        default: "/backend/api/",
    },
    internalApi: {
        type: String,
        default: "/de/api/",
    },
    locale: {
        type: String,
        default: "de-DE",
    },
});

const store = useSearchStore();
const { initSearch, isAPalmDevice, initSearchResult } = store;
const showTeaser = computed(() => {
    return store.hasTeaser;
});
const openRestoreModal = computed(() => {
    return store.isRestoreModalOpen;
});
const teaserHeight = ref(0);
const teaserBox = ref<HTMLElement>();
const searchApp = ref<HTMLElement>();
const isSearchBarActive = computed(() => {
    return store.isSearchBarActive;
});
const { mapCurrent } = useScreens({
    lapAndUp: DEFAULT_BREAKPOINT_DEFINITIONS.lapAndUp,
});

setI18nLocale(props.locale);

const isMobile = mapCurrent({ lapAndUp: false }, true);
function getTeaserHeight() {
    if (teaserBox.value) {
        teaserHeight.value = teaserBox.value?.offsetHeight;
    }
}

function closeActiveSearchBar() {
    if (isSearchBarActive.value) {
        store.openSearchBar(false);
    }
}

initSearch(
    props.apiEndpoint,
    props.ident,
    props.isWhitelabel,
    props.isIframe,
    props.backendApiEndpoint,
    props.internalApi,
    props.locale
);

onBeforeMount(async () => {
    await initSearchResult();
});

onMounted(() => {
    isAPalmDevice(isMobile.value);
});
</script>
<template>
    <div
        :class="[
            { 'is-show-teaser': showTeaser },
            { 'active-search-bar': isSearchBarActive },
        ]"
        ref="searchApp"
        @click="closeActiveSearchBar"
    >
        <div class="[ c-teaser-wrapper ]" ref="teaserBox">
            <teaser />
        </div>
        <div class="[ c-search ]">
            <search-filter-box
                :is-iframe="isIframe"
                :teaser-height="teaserHeight"
                :key="teaserHeight"
                @getTeaserOffset="getTeaserHeight"
            />
            <div class="[ c-result ]">
                <div v-if="isSearchBarActive" class="[ c-backdrop ]"></div>
                <div class="[ c-result-wrap ]">
                    <result-items v-if="store.isInitialized" />
                    <pagination />
                </div>
            </div>
        </div>
    </div>
    <restore-modal v-if="openRestoreModal" />
</template>
<style lang="scss">
@import "../scss/main";
</style>
